// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"82764a57","103":"867ecb10","139":"28cfc1e5","177":"7b3e1938","211":"8689a4ae","383":"f449f1e2","431":"9be98ace","453":"8fe512b0","662":"5e02648d","670":"92926d1f","678":"c9ba271f","932":"d0fc2da1"}[chunkId] + ".chunk.js";
};